import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'badge'
});
/**
 * A **Badge** displays concise information such as an icon, number or text.
 */

export var Badge = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      variant = _ref.variant,
      leftIcon = _ref.leftIcon,
      size = _ref.size,
      _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "variant", "leftIcon", "size", "as", "children"]);

  return _jsxs(As, _objectSpread(_objectSpread({
    className: "".concat(className, " _spark_badge_").concat(size),
    ref: ref,
    sx: {
      variant: variantPath(variant),
      display: 'inline-flex',
      whiteSpace: 'nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'base'
    }
  }, props), {}, {
    children: [leftIcon ? _jsx("div", {
      sx: {
        mr: size === 'small' ? 'xxxs' : 'xxs',
        'img,svg': {
          display: 'block',
          size: size === 'large' ? '20px' : '14px'
        }
      },
      children: leftIcon
    }) : null, children]
  }));
});
Badge.propTypes = {
  /**
   * The element to use as icon, hidden if undefined
   */
  leftIcon: PropTypes.element,

  /**
   * The element to use for establishing badge size; the default size is small.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Badge variant used to style it
   */
  variant: PropTypes.oneOf(['base', 'error', 'warning', 'success', 'light', 'dark', 'primary']).isRequired
};
Badge.defaultProps = {
  size: 'small',
  variant: 'base'
};
Badge.displayName = 'Badge';